import React from 'react';

import { Box } from '@mui/joy';
import { useColorScheme } from '@mui/joy/styles';

import step1PreviewDark from '../../../assets/onboarding/queue-step1-preview-dark.png';
import step1Preview from '../../../assets/onboarding/queue-step1-preview.png';

// Onboarding Step 1 preview — exported DIRECTLY from the Figma node as an image
// rather than pixel-coded with components. Keeps it 1:1 with the design, and
// (unlike the coded mini-table, whose sticky cells painted over the card's close
// button) it never obscures the popover's close X. Light = node 622:132640;
// dark = node 661:153968 (both 501x256 @3x) — swapped by theme so dark mode no
// longer shows the light screenshot on a dark card.
export const QueueStep1Preview: React.FC = () => {
  const { mode, systemMode } = useColorScheme();
  const isDark = (mode === 'system' ? systemMode : mode) === 'dark';
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box
        component='img'
        src={isDark ? step1PreviewDark : step1Preview}
        alt=''
        // 501x256; scale responsively within the 532 card content width.
        sx={{ width: 501, maxWidth: '100%', height: 'auto', display: 'block' }}
      />
    </Box>
  );
};

export default QueueStep1Preview;
